<template>
  <div class="categoriesWithListSlider">
    <SwiperSlider ref="slider" class="categoriesWithListSlider__swiper" :options="swiperOptions">
      <template v-for="(childCat, childCatIndex) in items">
        <div
          class="categoriesWithListSlider__slide swiper-slide"
          :key="childCatIndex"
          v-if="childCat.isUserAllowedToOrderItems"
        >
          <info-small-tile
            center-content
            class="categoriesWithListSlider__tile"
            @mouseover.native.once="
              childCat?.children?.length > 0 && $device.isDesktop ? setMinHeight(childCatIndex) : ''
            "
          >
            <nuxt-link
              :to="
                localePath({
                  name: 'category-slug',
                  params: { slug: childCat.slug },
                })
              "
              class="categoriesWithListSlider__tileWrapperLink"
            />
            <div class="categoriesWithListSlider__tileImageWrapper">
              <new-image-box
                v-if="childCat.smallImageUrl"
                background-color="#fff"
                :alt="childCat.name"
                :src="childCat.smallImageUrl"
                :width="200"
                :height="100"
                center-image
                image-params="w_200,h_110"
              />
              <image-placeholder v-else class="categoryNav__contentBannerImage" />
            </div>
            <div ref="subcatListParentText" class="categoriesWithListSlider__tileText">
              <h3 class="categoriesWithListSlider__tileTitle">
                <nuxt-link
                  :to="
                    localePath({
                      name: 'category-slug',
                      params: { slug: childCat.slug },
                    })
                  "
                  class="categoriesWithListSlider__tileCatLink"
                >
                  {{ childCat.name }}
                </nuxt-link>
              </h3>

              <p
                v-if="countCanBeOrdered(childCat.children) > 0 && $device.isDesktop"
                class="categoriesWithListSlider__tileSubtitle"
              >
                {{ countCanBeOrdered(childCat.children) }}
                <template v-if="countCanBeOrdered(childCat.children) > 4"> podkategorii </template>
                <template v-else> podkategorie </template>
              </p>
            </div>
            <ul
              v-if="childCat?.children?.length > 0 && $device.isDesktop"
              ref="subcatList"
              class="categoriesWithListSlider__tileSubcats"
            >
              <template v-for="(subcat, index) in childCat.children">
                <li
                  :key="index"
                  class="categoriesWithListSlider__tileSubcat"
                  v-if="subcat.isUserAllowedToOrderItems"
                >
                  <nuxt-link
                    :to="
                      localePath({
                        name: 'category-slug',
                        params: { slug: subcat.slug },
                      })
                    "
                    class="categoriesWithListSlider__tileSubcatLink"
                  >
                    {{ subcat.name }}
                  </nuxt-link>
                </li>
              </template>
            </ul>
          </info-small-tile>
        </div>
      </template>
    </SwiperSlider>
    <div class="categoriesWithListSlider__navigation swiper-navigation">
      <button
        class="categoriesWithListSlider__navigationButton categoriesWithListSlider__navigationButton--prev swiper-button-prev"
        @click="prevEl"
        ref="categoriesWithListSliderPrev"
      >
        <span class="categoriesWithListSlider__navigationButtonIcon icon-chevron-left-bold"></span>
      </button>
      <button
        class="categoriesWithListSlider__navigationButton categoriesWithListSlider__navigationButton--next swiper-button-next"
        @click="nextEl"
        ref="categoriesWithListSliderNext"
      >
        <span class="categoriesWithListSlider__navigationButtonIcon icon-chevron-right-bold"></span>
      </button>
    </div>
  </div>
</template>

<script>
import InfoSmallTile from '~/components/InfoSmallTile';
import SwiperSlider from '@/components/SwiperSlider';
import NewImageBox from '@/components/NewImageBox';
import ImagePlaceholder from '~/components/ImagePlaceholder';

export default {
  name: 'CategoriesWithListSlider',
  components: { SwiperSlider, InfoSmallTile, NewImageBox, ImagePlaceholder },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        allowTouchMove: false,
        navigation: true,
      },
    };
  },
  computed: {
    swiper() {
      if (typeof this.$refs.slider.swiper !== 'undefined') {
        return this.$refs.slider.swiper;
      }
      return false;
    },
  },
  mounted() {
    if (this.swiper) {
      this.swiper.on('slideChange', () => {
        this.checkArrows();
      });

      this.swiper.once('update', () => {
        this.swiper.on('slideChange', () => {
          this.checkArrows();
        });
      });

      this.checkArrows();
    }
  },
  methods: {
    countCanBeOrdered(categories) {
      return categories.filter(category => category.isUserAllowedToOrderItems).length;
    },
    checkArrows() {
      if (this.swiper.isEnd) {
        this.$refs.categoriesWithListSliderNext.addClass(
          'categoriesWithListSlider__navigationButton--disabled',
        );
      } else {
        this.$refs.categoriesWithListSliderNext.removeClass(
          'categoriesWithListSlider__navigationButton--disabled',
        );
      }

      if (this.swiper.activeIndex === 0) {
        this.$refs.categoriesWithListSliderPrev.addClass(
          'categoriesWithListSlider__navigationButton--disabled',
        );
      } else {
        this.$refs.categoriesWithListSliderPrev.removeClass(
          'categoriesWithListSlider__navigationButton--disabled',
        );
      }
    },
    setMinHeight(index) {
      if (this.$refs.subcatList[index]) {
        this.selectedItem = this.$refs.subcatList[index];
        const itemHeight = this.selectedItem.clientHeight;
        this.selectedItem.style.minHeight = `${itemHeight}px`;
      }
    },
    prevEl() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    nextEl() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.categoriesWithListSlider {
  $root: &;
  position: relative;
  margin-bottom: 3rem;
  background: $cWhite;
  z-index: 4;
  width: 100%;

  &__swiper.swiper-container {
    overflow: unset;
  }

  &__slide {
    height: auto;
    width: 25%;

    @include rwd('large-tablet') {
      width: 33.333%;
    }

    @include rwd('tablet') {
      width: 50%;
    }

    @include rwd('large-phone') {
      width: 100%;
    }
  }

  &__inner {
    position: relative;
  }

  &__navigationButton {
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: $cWhite;
    box-shadow: 0 3px 3px rgba($cMainDark, 0.1);
    z-index: 1;

    &--disabled {
      display: none;
    }

    &.swiper-button-disabled {
      display: none;
    }

    &::after {
      display: none;
    }

    &--prev {
      left: -20px;
    }

    &--next {
      right: -20px;
    }
  }

  &__navigationButtonIcon {
    font-size: 1.4rem;
    line-height: 1;
    color: $cAddDark;
  }

  &__tiles {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    border-style: solid;
    border-color: $cAddLight;
  }

  &__tile {
    height: 100%;
    cursor: pointer;
    margin: 0 -1px -1px 0;
    border: 1px solid #e1e1e1;
    min-height: 26.3rem;
    position: relative;
    overflow: hidden;
    padding: 2rem;
    transition: opacity $tr;

    @include rwd('large-tablet', true) {
      &:hover {
        overflow: visible;

        #{$root}__tileImageWrapper {
          opacity: 0.7;
        }

        #{$root}__tileSubcats {
          opacity: 1;
          z-index: 1000;
        }

        #{$root}__tileSubcat {
          transform: translateY(0);
        }
      }
    }

    @include rwd('tablet') {
      min-height: 16rem;
    }
  }

  &__tileWrapperLink {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
  }

  &__tileImageWrapper {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 11rem;
    margin-bottom: 1.5rem;
    width: 100%;
    transition: opacity $tr;

    @include rwd('small-tablet') {
      align-items: center;
    }
  }

  &__tileImage {
    max-height: 11rem;
    max-width: 100%;

    @include rwd('large-phone') {
      max-height: 8rem;
      max-width: 7rem;
    }
  }

  &__tileText {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;
  }

  &__tileTitle {
    text-align: center;
    max-width: 85%;
  }

  &__tileCatLink {
    color: $cMainDark;
    font-size: 2rem;
    line-height: 2.7rem;

    @include rwd('tablet') {
      font-size: 1.8rem;
      line-height: 2.2rem;
    }
  }

  &__tileSubtitle {
    color: $cMainLight;
    font-size: 1.6rem;
    line-height: 2rem;

    @include rwd('tablet') {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }

  &__tileSubcats {
    transform: translateY(100%);
    opacity: 0;
    background: $cWhite;
    border: 0.5px solid $cAddLight;
    border-top: 0;
    width: calc(100% + 2px);
    bottom: 0;
    position: absolute;
    padding: 0 2rem 2rem;
    transition: opacity $tr, transform $tr;

    @include rwd('large-laptop') {
      bottom: 4px;
    }
  }

  &__tileSubcat {
    color: $cMainLight;
    text-align: center;
    font-size: 1.6rem;
    line-height: 2rem;
    margin-bottom: 0.5rem;
    transform: translateY(-50%);
    transition: transform $trM;
  }

  &__tileSubcatLink {
    display: block;
    transition: color $tr;
    &:hover {
      color: $cSec;
    }
  }
}
</style>
